// Thiland
export const TRANSLATIONS_TH = {
  "home_header_selectlang": "เลือกภาษา",
  "home_header_loginbutton": "เข้าสู่ระบบ",
  "home_header_signupbutton": "ลงชื่อ",
  "home_header_homebutton": "บ้าน", 
  
  "home_register_bannertxt1": "ที่นี่ของคุณ",
  "home_register_bannertxt2": "ความคิด",
  "home_register_bannertxt3": "สามารถดึงคุณได้",
  "home_register_bannertxt4": "รางวัล$",
  "home_register_bannertxt5": "รับโบนัส",
  "home_register_bannertxt6": "เกี่ยวกับ SignUp",
  "home_register_fbsignup": "ลงทะเบียนกับ FACEBOOK",
  "home_register_fblogin": "เข้าสู่ระบบด้วย FACEBOOK",
  "home_register_or": "หรือ",
  "home_register_emailsignup": "ลงทะเบียนกับอีเมล",
  "home_register_emaillogin": "เข้าสู่ระบบด้วยอีเมล",
  "home_register_fpass": "ลืมรหัสผ่าน?",
  "home_register_fname": "ชื่อจริง",
  "home_register_lname": "นามสกุล",
  "home_register_email": "ที่อยู่อีเมล",
  "home_register_pass": "รหัสผ่าน",
  "home_register_cpass": "ยืนยันรหัสผ่าน",
  "home_register_tcpp": "โดยการเข้าร่วมคุณตกลงที่จะให้เรา",
  "home_register_tcpptandcond": "ข้อตกลงและเงื่อนไข",
  "home_register_tcppand": "และ",
  "home_register_tcppprivacy": "นโยบายส่วนบุคคล",
  "home_register_join": "เข้าร่วมกับเรา. นั่นฟรี",
  "home_register_login": "เข้าสู่ระบบ",
  "home_register_name_required" : "ต้องระบุชื่อ",
  "home_register_email_required" : "จำเป็นต้องใช้อีเมล",
  "home_register_invalid_email" : "รูปแบบอีเมลไม่ถูกต้อง",
  "home_register_password_required" : "ต้องการรหัสผ่าน.",
  "home_register_password_lower_digit" : "ต้องระบุรหัสผ่าน 6 หลัก",
  "home_register_password_higher_digit" : "ต้องใช้รหัสผ่าน 15 หลัก",
  "home_register_cpassword_required" : "ต้องระบุรหัสผ่าน",
  "home_register_cpassword_lower_digit" : "รหัสยืนยันต้องเป็นตัวเลข 6 หลัก",
  "home_register_cpassword_higher_digit" : "ต้องใช้รหัสผ่าน 15 หลัก",
  "home_register_cpassword_not_match" : "ยืนยันรหัสผ่านไม่ตรงกัน",

  "home_register_fp_not_worry" : "กรุณาใส่รหัสอีเมล์ที่ลงทะเบียนไว้", 
  "home_register_fp_resetpass_msg" : "หากต้องการรีเซ็ตรหัสผ่านโปรดป้อนอีเมลที่ลงทะเบียนไว้", 
  "home_register_fp_enter_email_msg" : "ใส่อีเมลของคุณที่นี่", 
  "home_register_fp_submit_button" : "ส่ง", 
  "home_register_fp_temporary_sent_pass_msg" : "การเชื่อมโยงรหัสผ่านรีเซ็ตได้ถูกส่งไปยังรหัสอีเมลที่ลงทะเบียนไว้แล้ว โปรดปรับปรุงรหัสผ่านของคุณที่เร็วที่สุด", 
  
  "home_works_howitworks": "มันทำงานอย่างไร?",
  "home_works_howitworkst1": "แนะนำตัวเอง",
  "home_works_howitworksd1": "สมัครสมาชิกลงชื่อสมัครใช้",
  "home_works_howitworkst2": "รับการสำรวจ",
  "home_works_howitworksd2": "เริ่มได้รับแบบสำรวจที่ใช้งานง่ายและเรียบง่าย",
  "home_works_howitworkst3": "รับคะแนน",
  "home_works_howitworksd3": "ให้คำตอบที่ดีที่สุดและสะสมคะแนน",
  "home_works_howitworkst4": "ไถ่ถอน",
  "home_works_howitworksd4": "แลกคะแนนสะสมของคุณด้วยรางวัลที่น่าสนใจมากมาย",

  "home_aboutus_whoweare": "พวกเราคือใคร?",
  "home_aboutus_whowearep1": "ที่ WisePerks เราทำงานอย่างหนักเพื่อให้แน่ใจว่าเวลาที่คุณใช้ออนไลน์เป็นประสบการณ์ที่คุ้มค่า เราทำงานร่วมกับ บริษัท หลายร้อยแห่งที่กระตือรือร้นที่จะได้รับความคิดเห็นของคุณทราบว่าคุณรู้สึกอย่างไรเกี่ยวกับผลิตภัณฑ์หรือบริการของตน คุณให้ความเห็นเกี่ยวกับบริการต่างๆ แต่บริการเหล่านี้ไม่ได้ให้รางวัลแก่คุณสำหรับเวลาของคุณซึ่งแตกต่างจาก WisePerks ซึ่งการสำรวจทุกครั้งที่คุณเข้าร่วมจะให้ผลตอบแทนที่คุ้มค่ากับเวลาของคุณ",
  "home_aboutus_whowearep2": "เราให้ความสำคัญกับข้อเสนอแนะของคุณและต้องการให้คุณได้รับรางวัลสำหรับเวลาของคุณ เรามีการสำรวจหัวข้อต่างๆเพื่อให้ตรงกับความสนใจของคุณและทำให้คำตอบง่าย คุณสามารถสร้างรายได้ประมาณ $ 50 ถึง $ 100 ทุกเดือนโดยการสำรวจต่างๆ ลองทำงานร่วมกันเพื่อให้มันเกิดขึ้น",
  
  "home_earn_more_surabt": "การสำรวจสิ่งที่ถาม?",
  "home_earn_more_bp": "ผู้เชี่ยวชาญด้านธุรกิจ",
  "home_earn_more_consumers": "ผู้ บริโภค",
  "home_earn_more_hc": "สุขภาพและฟิตเนส",
  "home_earn_more_entertainment": "สนุกสนานและสนุก",
  "home_earn_more_gaming": "เกมประหลาด",
  "home_earn_more_tech": "ชาญเทคโนโลยี",
  "home_earn_more_bonus_survey": "การสำรวจโบนัส", 
  
  "home_reward_whatuearn": "สิ่งที่คุณได้รับ?",
  "home_reward_whatuearnp1": "เราชอบที่จะให้สิ่งที่ง่าย. คุณได้รับคะแนนสำหรับการสำรวจเสร็จสมบูรณ์ทั้งหมด การสำรวจเพิ่มเติมที่คุณทำเสร็จสมบูรณ์คุณจะได้รับคะแนนมากกว่า สามารถแลกคะแนนสะสมสำหรับบัตรของขวัญที่คุณเลือกหลังจากที่คุณข้ามเกณฑ์หนึ่งแล้ว",
  "home_reward_whatuearnp2": "เมื่อพร้อมที่จะแลกแล้วเลือกตัวเลือกที่คุณต้องการเช่น Amazon, Starbucks, iTunes และอื่น ๆ อีกมากมาย เรายังให้โบนัสและขอบคุณพระเจ้าข้อเสนอในวันศุกร์เป็นครั้งคราว",
  
  "home_counter_earnedover": "สมาชิกได้รับมากกว่า",
  
  "home_contact_getintouch": "ได้รับการติดต่อ",
  "home_contact_emailus": "สำหรับคำถามใด ๆ โปรดส่งอีเมลถึงเราที่",
  
  "home_footer_faq": "คำถามที่พบบ่อย",
  "home_footer_pp": "นโยบายส่วนบุคคล",
  "home_footer_tc": "T & C",
  "home_footer_uf": "คุณสมบัติที่จะเกิดขึ้น",
  "home_footer_copyright": "ลิขสิทธิ์© current_year WisePerks สงวนลิขสิทธิ์.",

  "home_header_home": "บ้าน", 
  "home_footer_toknowmore": "ต้องการทราบข้อมูลเพิ่มเติม",
  "home_footer_createacc": "สร้างบัญชีฟรีและเข้าร่วมสมาชิกสุขสันต์มากมายของเรา",
  "home_footer_registernow": "สมัครตอนนี้",

  "home_reset_password" : "รีเซ็ตรหัสผ่าน", 
  "home_reset_pass_content" : "คุณได้ร้องขอให้ตั้งค่ารหัสผ่านใหม่สำหรับ",

  "dashboard_sidebar_selectavatar" : "เลือก avatar ของคุณ", 
  "dashboard_sidebar_uploadavatar" : "คลิกที่นี่เพื่ออัพโหลดรูปภาพ", 
  "dashboard_sidebar_pbank" : "คะแนนธนาคาร",
  "dashboard_sidebar_accumulated" : "รับ", 
  "dashboard_sidebar_realized" : "ตระหนัก ถึง",
  "dashboard_sidebar_pending" : "การปรับ", 
  "dashboard_sidebar_earned_tooltip" : "คะแนนที่คุณได้รวบรวมไว้",
  "dashboard_sidebar_pending_tooltip" : "คะแนนที่ต้องย้อนกลับจากบัญชีของคุณ",
  "dashboard_sidebar_main" : "หลัก",
  "dashboard_sidebar_dashboard" : "แผงควบคุม",
  "dashboard_sidebar_profile" : "ข้อมูลส่วนตัว",
  "dashboard_sidebar_updateprofile" : "อัพเดตโปรไฟล์",
  "dashboard_sidebar_shistory" : "ประวัติการสำรวจ",
  "dashboard_sidebar_mtrans" : "การทำธุรกรรมของฉัน",
  "dashboard_sidebar_passbook" : "คะแนนสะสม",
  "dashboard_sidebar_redeem" : "ไถ่ถอน",
  "dashboard_sidebar_refer_friend" : "แนะนำเพื่อน",
  "dashboard_sidebar_logout" : "ออกจากระบบ",

  "dashboard_sidebar_tutorial1" : "แสดงการสำรวจที่มีอยู่ทั้งหมดและสิ่งที่คุณสามารถได้รับจากพวกเขา",
  "dashboard_sidebar_tutorial2" : "ตอบคำถามเพียงเล็กน้อยที่นี่เพื่อแจ้งให้เราทราบว่าคุณดีกว่าและช่วยเราในการส่งแบบสำรวจความสนใจของคุณ โปรดทราบคำถามที่คุณจะไม่สามารถปรับปรุงการตอบสนองของคุณหลังจากที่ส่ง",
  "dashboard_sidebar_tutorial2update" : "คุณสามารถอัปเดตคำตอบได้ที่นี่ แต่จะมีคำถามสองสามข้อที่ไม่สามารถอัปเดตได้",
  "dashboard_sidebar_tutorial3" : "ค้นหาแบบสำรวจทั้งหมดที่คุณพยายาม",
  "dashboard_sidebar_tutorial4" : "ช่วยให้คุณติดตามการทำธุรกรรมทั้งหมดของคุณบน WisePerks",
  "dashboard_sidebar_tutorial5" : "ไม่กี่ขั้นตอนที่รวดเร็วในการแปลงคะแนนที่เกิดขึ้นจริงของคุณให้เป็นรางวัล",
  "dashboard_sidebar_tutorial6" : "ดูประวัติการทำธุรกรรมทั้งหมดของคะแนนที่เดบิต / โอนเข้าบัญชีของคุณ",
  "dashboard_sidebar_gotit" : "เข้าใจแล้ว",

  "dashboard_sidebar_note" : "โปรดทราบ",
  "dashboard_sidebar_note1" : "คำตอบทั้งหมดต้องตอบโดยสุจริต",
  "dashboard_sidebar_note2" : "โปรดเจาะจงและกระชับด้วยคำตอบที่เปิดกว้าง",
  "dashboard_sidebar_note3" : "อย่าเร่งความเร็ว! กำหนดเวลาสํารวจการสํารวจขั้นต่ำแล้ว",
  "dashboard_sidebar_note4" : "โปรดให้คำตอบที่สอดคล้องกันเมื่อถามคำถามเดียวกัน",
  "dashboard_sidebar_note5" : "แบบสำรวจใหม่จะถูกเพิ่มและปิดจะถูกลบออกจากแดชบอร์ดของคุณโดยอัตโนมัติ",
  "dashboard_sidebar_note6" : "รับคะแนนอย่างรวดเร็วเพียงแค่อ้างอิง",

  "dashboard_setting_hi" : "สวัสดี",
  "dashboard_setting_minfo" : "ข้อมูลสมาชิก",
  "dashboard_setting_macc" : "จัดการบัญชี",
  "dashboard_setting_upass" : "อัปเดตรหัสผ่าน",
  "dashboard_setting_yourname" : "ชื่อของคุณ",
  "dashboard_setting_fname" : "ชื่อจริง",
  "dashboard_setting_lname" : "นามสกุล",
  "dashboard_setting_save" : "บันทึกการเปลี่ยนแปลง",
  "dashboard_setting_bornon" : "คุณเกิดมา",
  "dashboard_setting_youare" : "คุณเป็น",
  "dashboard_setting_postal" : "รหัสไปรษณีย์ของคุณคือ",
  "dashboard_setting_emailus" : "สำหรับความช่วยเหลือหรือแบบสอบถามใดๆโปรดส่งอีเมลไปยัง",
  "dashboard_setting_membersince" : "คุณเป็นสมาชิกตั้งแต่",
  "dashboard_setting_taken" : "คุณได้ถ่าย",
  "dashboard_setting_completed" : "การสำรวจและเสร็จสิ้น",
  "dashboard_setting_ofthem" : "ของพวกเขา.",
  "dashboard_setting_earned" : "คุณได้รับแล้ว",
  "dashboard_setting_pts" : "จุด",
  "dashboard_setting_started" : "ตั้งแต่คุณเริ่มต้น",
   "dashboard_register_email" : "คุณลงทะเบียนกับเราจาก",
  "dashboard_setting_preferences" : "จัดการค่ากำหนดของคุณ",
  "dashboard_setting_emailoptout" : "เลือกไม่ใช้อีเมล",
  "dashboard_setting_futureemails" : "เลือกไม่รับอีเมลในอนาคตจาก WisePerks",
  "dashboard_setting_futureemailsflash" : "อีเมลของเราให้คุณโพสต์ในทุกการสำรวจที่ร่ำรวยที่มีให้คุณ. คุณแน่ใจหรือไม่ว่าคุณไม่ต้องการรับ",
  "dashboard_setting_nrecemail" : "อีเมลของเราให้คุณโพสต์ในทุกการสำรวจที่ร่ำรวยที่มีให้คุณ. คุณแน่ใจหรือไม่ว่าคุณไม่ต้องการหยุด",
  "dashboard_setting_emailout_modalmsg" : "คุณแน่ใจหรือไม่ว่าคุณต้องการยกเลิกการรับอีเมลในอนาคตจาก WisePerks?",
  "dashboard_setting_emailin_modalmsg" : "คุณแน่ใจหรือไม่ว่าเริ่มต้นรับอีเม WisePerks ในอนาคต",
  "dashboard_setting_emailout_succmsg" : "ของคุณได้สำเร็จหยุดรับอีเมลจาก WisePerks",
  "dashboard_setting_emailin_succmsg" : "คุณได้เริ่มต้นรับอีเมลจาก WisePerks",
  "dashboard_setting_deactivateacc" : "ปิดการใช้งานบัญชี",
  "dashboard_setting_disableprofile" : "การปิดใช้งานบัญชีของคุณจะทำให้โปรไฟล์ของคุณปิดใช้งานจาก WisePerks",
  "dashboard_setting_deactivateacc_msg" : "คุณแน่ใจหรือไม่ว่าคุณต้องการปิดใช้งานบัญชีของคุณบน WisePerks?",
  "dashboard_setting_deactivateacc_flash" : "หากคุณมีข้อร้องเรียนหรือคำติชมใดๆโปรดแบ่งปันกับเรา เราจะอยู่ในลำดับความสำคัญ. ทำให้เรามีโอกาส คุณแน่ใจหรือไม่ว่าคุณต้องการที่จะลบบัญชีของคุณกับเรา",
  "dashboard_setting_changelang" : "เปลี่ยนภาษา",
  "dashboard_setting_preferredlang" : "เลือกภาษาที่คุณต้องการ",
  "dashboard_setting_updatepass" : "อัปเดตรหัสผ่าน",
  "dashboard_setting_plsupdate" : "โปรดปรับปรุงรหัสผ่านของคุณด้านล่าง",
  "dashboard_setting_oldpass" : "รหัสผ่านเก่า",
  "dashboard_setting_enteroldpass" : "ป้อนรหัสผ่านเดิม",
  "dashboard_setting_newpass" : "รหัสผ่านใหม่",
  "dashboard_setting_enternewpass" : "ใส่รหัสผ่านใหม่",
  "dashboard_setting_confpass" : "ยืนยันรหัสผ่าน",
  "dashboard_setting_enternewpassagain" : "ป้อนรหัสผ่านใหม่อีกครั้ง",
  "dashboard_setting_update" : "ปรับปรุง",

  "dashboard_doi_welcome" : "ยินดี ต้อน รับ สู่",
  "dashboard_doi_welbck" : "ยินดีต้อนรับกลับ",
  "dashboard_doi_accntverified" : "ดูเหมือนว่าคุณพลาดการยืนยันบัญชีอีเมลของคุณ", 
  "dashboard_doi_getaccess" : "รีบ! คุณจะได้รับ",
  "dashboard_doi_getaccess2" : "จุดเมื่อคุณตรวจสอบ",
  "dashboard_doi_activateacc" : "กรุณาตรวจสอบกล่องขาเข้าของคุณและคลิกลิงก์ที่ระบุในอีเมลยืนยันบัญชีที่ส่งไปยังบัญชีอีเมลที่ลงทะเบียนไว้",
  "dashboard_doi_chckspam" : "กรุณาตรวจสอบโฟลเดอร์สแปม/ขยะของคุณในกรณีที่คุณไม่สามารถค้นหาอีเมลการตรวจสอบ",
  "dashboard_doi_didntgetconf" : "ไม่ได้รับอีเมลยืนยัน?", 
  "dashboard_doi_resendconf" : "ส่งอีเมลยืนยันอีกครั้ง", 
  "dashboard_doi_resendconfsucc" : "อีเมลการตรวจสอบได้ถูกส่งไปยังอีเมลที่ลงทะเบียนแล้ว", 
  
  "dashboard_survey_availsurveys" : "แบบสำรวจที่มีให้",
  "dashboard_survey_wisechecksurveys1" : "คุณไม่สามารถดูการสำรวจเนื่องจากเหตุผลด้านความปลอดภัยบางอย่าง กรุณาติดต่อฝ่ายสนับสนุนบน",
  "dashboard_survey_wisechecksurveys2" : ".",
  "dashboard_survey_unsubscribesurveys" : "ไม่มีการสำรวจสำหรับเหตุผลการยกเลิกการสมัครสมาชิก",
  "dashboard_featured" : "น่า สนใจ",
  "dashboard_profile_survey" : "การสำรวจโปรไฟล์",
  "dashboard_survey_start" : "เริ่มต้น",
  "dashboard_survey_on" : "บน",
  "dashboard_survey_off" : "ปิด",
  "dashboard_survey_point": "จุด",
  "dashboard_survey_points" : "จุด",
  "dashboard_survey_minute" : "นาที",
  "dashboard_survey_minutes" : "นาที",

  "demography_hi" : "สวัสดี",
  "demography_welcome" : "ยินดีต้อนรับสู่ WisePerks คุณเพิ่งได้รับตัวเอง",
  "demography_points" : "คะแนนโดยการลงทะเบียนกับเรา",
  "demography_share" : "กรุณาแบ่งปันรายละเอียดบางอย่างในแบบฟอร์มด้านล่างเพื่อช่วยให้เราในการสำรวจที่เกี่ยวข้องกับคุณ",

  "demography_gender" : "ฉันคือ",
  "demography_male" : "ชาย",
  "demography_female" : "หญิง",
  "demography_birthday" : "วันเกิด",
  "demography_month" : "เดือน", 
  "demography_day" : "วัน", 
  "demography_year" : "ปี", 
  "demography_jan" : "มกราคม",
  "demography_feb" : "กุมภาพันธ์",
  "demography_mar" : "มีนาคม",
  "demography_apr" : "เมษายน",
  "demography_may" : "อาจ",
  "demography_jun" : "มิถุนายน",
  "demography_jul" : "กรกฎาคม",
  "demography_aug" : "สิงหาคม",
  "demography_sep" : "กันยายน",
  "demography_oct" : "ตุลาคม",
  "demography_nov" : "พฤศจิกายน",
  "demography_dec" : "ธันวาคม",
  "demography_hearabout" : "คุณรู้จัก WisePerks ที่ไหนแล้ว?",
  "demography_opt1" : "เลือกสิ่งที่ใกล้เคียงที่สุดที่ใช้",
  "demography_opt2" : "อีเมล์ / จดหมายข่าว",
  "demography_opt3" : "Facebook",
  "demography_opt4" : "ฟอรัมหรือบล็อก",
  "demography_opt5" : "เพื่อน",
  "demography_opt6" : "LinkedIn",
  "demography_opt7" : "เครื่องมือค้นหา",
  "demography_opt8" : "โฆษณาทางโทรทัศน์",
  "demography_opt9" : "ทวิตเตอร์",
  "demography_opt10" : "เว็บ ไซต์",
  "demography_opt11" : "Youtube",
  "demography_opt12" : "อื่นๆ",
  "demography_zipcode": "รหัสไปรษณีย์",
  "demography_submit" : "ส่ง",

  "privacypolicy_privacypolicy" : "นโยบายส่วนบุคคล",
  "privacypolicy_privacyisimp" : "ความเป็นส่วนตัวของคุณเป็นสิ่งสำคัญสำหรับเรา",
  "privacypolicy_lastupdated" : "อัปเดตล่าสุดเมื่อวันที่",

  "privacypolicy_para1" : 'WiseWorks (ร่วมกับ บริษัท ในเครือ "บริษัท ") เป็นเจ้าของและดำเนินการเว็บไซต์ต่างๆแอปบนอุปกรณ์เคลื่อนที่และบริการเชิงโต้ตอบต่างๆรวมถึง แต่ไม่ จำกัด เพียง Wisesample.com, Flapbucks.com, WisePerks.com และอื่น ๆ (รวมเรียกว่า " WiseWorks Sites ")นโยบายส่วนบุคคล ("นโยบายความเป็นส่วนตัว") นี้ใช้กับเว็บไซต์ WiseWorks รวมถึงคุณลักษณะต่างๆแอพพลิเคชั่นโทรศัพท์มือถืออีเมลบริการออนไลน์และฟังก์ชันการทำงานอื่น ๆ ไม่ว่าจะเข้าถึงผ่านทางคอมพิวเตอร์อุปกรณ์เคลื่อนที่หรือบริการอื่น ๆ ที่มีอยู่หรือผ่านทาง ไซต์ WiseWorks และคุณลักษณะ ("บริการ")นโยบายความเป็นส่วนตัวนี้ครอบคลุมเฉพาะข้อมูลที่เก็บรวบรวมโดย บริษัท ผ่านเว็บไซต์และคุณลักษณะของ WiseWorks และบริการของเราและไม่ครอบคลุมถึงข้อมูลใด ๆ ที่ได้รับหรือรวบรวมแบบออฟไลน์โดย บริษัท (เว้นแต่ระบุไว้เป็นพิเศษ) หรือที่เก็บรวบรวมโดยเว็บไซต์หรือ บริษัท ที่ไม่เกี่ยวข้องซึ่งเราอาจ ให้ลิงก์',

  "privacypolicy_para2" : "คาดว่าผู้สอบบัญชีจะต้องกรอกข้อมูลอย่างถูกต้องและซื่อสัตย์โดยไม่ส่งข้อมูลผิดหรือไม่ถูกต้องเพื่อให้มีสิทธิ์ได้รับการสำรวจเพิ่มเติมนอกจากนี้คาดว่าผู้เข้าร่วมประชุม / ผู้ตอบจะไม่ใช้คำตอบของเขาหรือใช้วิธีอื่นที่ไม่เป็นธรรม (เปลี่ยน IP ฯลฯ ) ในระหว่างการกรอกแบบสอบถามเพื่อหาแรงจูงใจWisePerks มีการป้องกันที่เพียงพอในการตรวจจับความผิดปกติดังกล่าวและหากสังเกตเห็นพฤติกรรมดังกล่าวผู้เข้าร่วมประชุมจะถูกแบน / บล็อกจาก WisePerks และคำขอแลกของรางวัลทั้งหมดจะถูกยกเลิก",

  "privacypolicy_para3" : "WiseWorks มุ่งมั่นที่จะปกป้องความเป็นส่วนตัวของคุณกับเรานโยบายส่วนบุคคลต่อไปนี้จะอธิบายถึงวิธีที่ข้อมูลส่วนบุคคลของคุณได้รับการเก็บรักษาไว้และปฏิบัติตามที่คุณสำรวจเว็บไซต์และบริการของเรา",

  "privacypolicy_topic1" : "ข้อมูลส่วนบุคคลใดที่ WisePerks.com รวบรวมได้จากฉัน",
  "privacypolicy_topic1ans" : "WisePerks.com รวบรวมข้อมูลในลักษณะต่างๆจากส่วนต่างๆของเว็บไซต์และเครือข่ายของเราข้อมูลบางอย่างถูกรวบรวมเมื่อคุณลงชื่อสมัครใช้ในระหว่างการลงทะเบียนสมาชิก WisePerks.com จะขอชื่อที่อยู่อีเมลรหัสไปรษณีย์และข้อมูลสำหรับใช้ในครัวเรือนของคุณข้อมูลเพิ่มเติมที่คุณอาสาสมัครเพื่อให้บริการได้อย่างถูกต้องดีกว่าเราสามารถให้บริการและรางวัลแก่คุณได้ดียิ่งขึ้นนอกจากนี้หากคุณเคยติดต่อ WisePerks.com ผ่านวิธีการใด ๆ เราอาจเก็บบันทึกการติดต่อนั้นไว้เมื่อใดก็ตามที่ WisePerks.com เก็บรวบรวมข้อมูลดังกล่าวเรามุ่งหวังให้มีลิงก์ไปยังนโยบายความเป็นส่วนตัวนี้ในหน้านั้น",

  "privacypolicy_topic2" : "คุกกี้คืออะไรและ WisePerks.com ใช้งานอย่างไร?",
  "privacypolicy_topic2ans" : "คุกกี้เป็นชุดข้อมูลอิเล็กทรอนิกส์ที่ส่งไปยังเบราเซอร์ของคุณจากเว็บเซิร์ฟเวอร์และเก็บไว้ในฮาร์ดไดรฟ์ของคอมพิวเตอร์ของคุณWisePerks.com อาจใช้คุกกี้เพื่อจัดเก็บและติดตามข้อมูลเกี่ยวกับคุณบางครั้งWisePerks.com อาจต้องการให้คุณยอมรับคุกกี้เพื่อเตรียมเนื้อหาเฉพาะดังกล่าวให้กับคุณนอกจากนี้ยังหลีกเลี่ยงการป้อนข้อมูลการเข้าสู่ระบบของคุณทุกครั้ง",

  "privacypolicy_topic3" : "นโยบาย WisePerks.com คืออะไรในการอนุญาตให้ฉันอัปเดตแก้ไขเปลี่ยนแปลงหรือลบข้อมูลบัญชีส่วนบุคคลของฉัน?",
  "privacypolicy_topic3ans" : "คุณสามารถแก้ไขข้อมูลบัญชี WisePerks.com ได้ตลอดเวลาโดยใช้ WisePerks.com Log in และรหัสผ่านของคุณโปรดติดต่อ",
  "privacypolicy_topic3ans2" : "สำหรับคำแนะนำเพิ่มเติมเกี่ยวกับการปิดใช้งานบัญชี WisePerks.com ของคุณ",

  "privacypolicy_topic4" : "ใครเป็นผู้รวบรวมข้อมูลและเพื่อวัตถุประสงค์อะไร?",
  "privacypolicy_topic4ansp1" : "WisePerks.com เก็บรวบรวมข้อมูลต่างๆผ่านการสำรวจและลงทะเบียนและวิธีการอื่น ๆ ซึ่งจะช่วยให้ลูกค้าที่เป็นนักวิจัยพัฒนาผลิตภัณฑ์และบริการใหม่ ๆ สำหรับผู้บริโภคคุณกำลังแชร์ข้อมูลดังกล่าวกับ WisePerks.com เท่านั้นเว้นแต่จะระบุไว้เป็นอย่างอื่นในการสำรวจที่คุณเข้าร่วมหากมีการเก็บรวบรวมข้อมูลและ / หรือดูแลรักษาข้อมูลโดย บริษัท อื่นที่ไม่ใช่ WiseWorks - หรือ WiseWorks คุณจะได้รับการแจ้งเตือนก่อนเวลารวบรวมหรือถ่ายโอนข้อมูลหากคุณไม่ต้องการแชร์ข้อมูลคุณอาจเลือกที่จะไม่อนุญาตการถ่ายโอนโดยไม่ใช้การสำรวจหรือผลิตภัณฑ์นั้น ๆ",
  "privacypolicy_topic4ansp2" : "รางวัลและโปรโมชันที่เรานำเสนอใน WisePerks.com อาจได้รับการสนับสนุนโดย บริษัท อื่น ๆ อย่างอิสระหรืออาจได้รับการสนับสนุนร่วมกันโดย WisePerks.com และ บริษัท อื่นข้อมูลบางอย่างที่เก็บรวบรวมในระหว่างการส่งเสริมดังกล่าวอาจถูกแชร์กับผู้สนับสนุนอย่างไรก็ตามคุณจะได้รับการแจ้งเตือนก่อนเวลาเก็บรวบรวมข้อมูลหรือโอนย้ายคุณสามารถตัดสินใจที่จะไม่เข้าร่วมโปรโมชันพิเศษนั้นได้หากไม่ต้องการแชร์ข้อมูล",
  "privacypolicy_topic4ansp3" : "ข้อมูลที่ละเอียดอ่อนเฉพาะใด ๆ (เช่นข้อมูลที่ระบุถึงสภาวะทางการแพทย์หรือสุขภาพที่มาจากเชื้อชาติหรือชาติพันธุ์ความคิดเห็นทางการเมืองความเชื่อทางศาสนาหรือจิตวิญญาณการค้าและการเป็นสมาชิกสหภาพแรงงานหรือข้อมูลที่ระบุถึงชีวิตทางเพศของแต่ละบุคคล) จะได้รับการดูแลเพิ่มเติมหาก WisePerks.com ประสงค์จะแบ่งปันข้อมูลดังกล่าวกับ บริษัท อื่นเพื่อวัตถุประสงค์อื่นนอกเหนือจากที่ได้เก็บรวบรวมไว้ก่อนแล้วคุณจะได้รับการขออนุญาตอย่างชัดแจ้งก่อนที่จะมีการเปิดเผยข้อมูลดังกล่าว",

  "privacypolicy_topic5" : "WisePerks.com แบ่งปันข้อมูลของฉันกับใครบ้าง?",
  "privacypolicy_topic5ansp1" : "เราให้ความสำคัญกับความเป็นส่วนตัวอย่างจริงจังWisePerks.com จะไม่เปิดเผยข้อมูลส่วนบุคคลใด ๆ ของคุณยกเว้นเมื่อได้รับอนุญาตอย่างชัดแจ้งจากคุณหรือภายใต้สถานการณ์พิเศษใด ๆ ที่กฎหมายกำหนดไว้หรือภายใต้สถานการณ์ที่ระบุในรายละเอียดด้านล่างข้อมูลต่อไปนี้อธิบายถึงวิธีการเปิดเผยข้อมูลของคุณบางส่วนโปรดดูที่ข้อกำหนดในการให้บริการสำหรับบริการของเราสำหรับข้อมูลเพิ่มเติมเกี่ยวกับการแบ่งปันข้อมูลส่วนบุคคลของคุณ",
  "privacypolicy_topic5ansp2" : "พันธมิตรธุรกิจลูกค้าและผู้สนับสนุน:",
  "privacypolicy_topic5ansp3" : "WisePerks.com อาจเปิดเผยข้อมูลส่วนบุคคลของคุณแก่คู่ค้าลูกค้าหรือผู้สนับสนุนของเราอย่างไรก็ตามหากมีการเปิดเผยข้อมูลส่วนบุคคลใด ๆ เกี่ยวกับตัวคุณเราจะแจ้งให้คุณทราบก่อนที่เราจะรวบรวมหรือถ่ายโอนข้อมูลกิจกรรมมากมายที่เรานำเสนอขอข้อมูลเพิ่มเติมจากผู้สนับสนุนเมื่อคุณขอข้อมูลเพิ่มเติมคุณให้สิทธิ์ WisePerks.com เพื่อแบ่งปันข้อมูลของคุณกับผู้สนับสนุนเพื่อให้สามารถตอบสนองคำขอของคุณได้ในหลาย ๆ กรณีระบบจะแบ่งปันที่อยู่อีเมลของคุณเท่านั้นหากมีการแชร์ข้อมูลเพิ่มเติมกับพันธมิตรของเราคุณจะได้รับแจ้งล่วงหน้าบางครั้งคุณอาจได้รับโอกาสในการได้รับวัสดุทดสอบหรือผลิตภัณฑ์อื่น ๆ หรือข้อเสนอพิเศษจากพันธมิตรของเราหากคุณเลือกที่จะรับข้อมูลจากบุคคลที่สามเหล่านี้ WisePerks.com จะ (โดยได้รับอนุญาตจากคุณ) แชร์ชื่อและที่อยู่อีเมลของคุณกับพวกเขา",
  "privacypolicy_topic5ansp4" : "WisePerks.com อาจเปิดเผยข้อมูลส่วนบุคคลในกรณีพิเศษบางกรณีเมื่อเปิดเผยข้อมูลนี้เป็นสิ่งที่จำเป็นในการระบุติดต่อหรือดำเนินการทางกฎหมายต่อบุคคลที่อาจละเมิดนโยบายและข้อกำหนดในการให้บริการของ WisePerks.com หรืออาจก่อให้เกิดความเสียหายต่อหรือ การแทรกแซงด้วยผลิตภัณฑ์บริการสิทธิหรือทรัพย์สินของ WisePerks.com สมาชิกและผู้ใช้ WisePerks.com และบุคคลอื่น ๆ ที่อาจได้รับผลกระทบจากกิจกรรมดังกล่าวWisePerks.com อาจเปิดเผยหรือเข้าถึงข้อมูลบัญชีเมื่อเราเชื่อโดยสุจริตว่ากฎหมายกำหนดไว้และเพื่อวัตถุประสงค์ด้านการบริหารและอื่น ๆ ที่เราเห็นว่าจำเป็นที่จะต้องรักษาบริการและปรับปรุงผลิตภัณฑ์และบริการของเรา",

  "privacypolicy_topic6" : "ฐานข้อมูลทางกฎหมายที่เราใช้ในการประมวลผลข้อมูลของคุณคืออะไร?",
  "privacypolicy_topic6ans" : 'WiseWorks มุ่งมั่นที่จะปกป้องข้อมูลส่วนบุคคลและข้อมูลนโยบายส่วนบุคคลของเราใช้หลักการของระเบียบว่าด้วยการคุ้มครองข้อมูลทั่วไปที่ออกโดยสหภาพยุโรป ("GDPR") เป็นเกณฑ์มาตรฐานที่เราพนักงานและซัพพลายเออร์ของเราปฏิบัติตาม',

  "privacypolicy_topic7" : "อะไรคือทางเลือกของฉันเกี่ยวกับการรวบรวมการใช้และการแจกจ่ายข้อมูลของฉัน?",
  "privacypolicy_topic7ans" : "เฉพาะ WisePerks.com (หรือคู่ค้าที่ร่วมงานกับ WisePerks.com ภายใต้ข้อตกลงในการรักษาความลับ) จะส่งอีเมลโดยตรงให้คุณเฉพาะกรณีที่คุณระบุว่าคุณไม่คัดค้านคุณมีตัวเลือกที่เกี่ยวข้องกับวิธีการทำงานของคุกกี้เมื่อเปลี่ยนการตั้งค่าเบราเซอร์อินเทอร์เน็ตคุณสามารถเลือกรับคุกกี้ทั้งหมดได้รับการแจ้งเตือนเมื่อมีการตั้งค่าคุกกี้หรือปฏิเสธคำขอคุกกี้ทั้งหมดหากคุณเลือกที่จะปฏิเสธคุกกี้ทั้งหมดคุณจะไม่สามารถใช้บริการ WisePerks.com เหล่านี้ซึ่งต้องได้รับการลงทะเบียนก่อนเพื่อเข้าร่วมWisePerks.com ไม่ได้ขายหรือให้เช่าข้อมูลผู้ใช้ใด ๆ ให้กับทุกคนเราจะแจ้งให้คุณทราบเสมอในขณะที่มีการเก็บรวบรวมข้อมูลหรือโอนย้ายหากข้อมูลของคุณจะถูกแชร์กับบุคคลที่สามและคุณจะมีทางเลือกในการไม่อนุญาตให้มีการแชร์",

  "privacypolicy_topic8" : "ข้อควรระวังด้านความปลอดภัยใดบ้างที่ WisePerks.com เพื่อป้องกันการสูญเสียการใช้ผิดวิธีหรือการเปลี่ยนแปลงข้อมูลบัญชีของฉัน?",
  "privacypolicy_topic8ansp1" : "ข้อมูลบัญชี WisePerks.com ของคุณได้รับการป้องกันด้วยรหัสผ่านเพื่อให้คุณและคุณสามารถเข้าถึงข้อมูลนี้ได้เท่านั้น",
  "privacypolicy_topic8ansp2" : "ขอแนะนำให้คุณอย่าแชร์รหัสผ่านกับทุกคนเราจะไม่ขอรหัสผ่านของคุณในการโทรหรืออีเมลที่ไม่พึงประสงค์โปรดออกจากระบบบัญชี WisePerks.com และปิดหน้าต่างเบราเซอร์เมื่อทำกิจกรรมเสร็จสิ้นเพื่อให้แน่ใจว่าผู้อื่นไม่สามารถเข้าถึงข้อมูลส่วนบุคคลและบัญชีของคุณได้หากคุณใช้คอมพิวเตอร์สาธารณะหรือแชร์คอมพิวเตอร์กับบุคคลอื่นเมื่อใดก็ตามที่ WisePerks.com จัดการข้อมูลส่วนบุคคลตามที่อธิบายข้างต้นโดยไม่คำนึงว่าจะทำเช่นไร WisePerks.com จะดำเนินการเพื่อให้มั่นใจว่าข้อมูลของคุณได้รับการปฏิบัติอย่างปลอดภัยและเป็นไปตามข้อกำหนดในการให้บริการที่เกี่ยวข้องและนโยบายความเป็นส่วนตัวนี้แต่น่าเสียดายที่ไม่มีการรับส่งข้อมูลผ่านอินเทอร์เน็ตสามารถรับประกันได้ว่าปลอดภัย 100%ดังนั้นในขณะที่เรามุ่งมั่นที่จะปกป้องข้อมูลส่วนบุคคลของคุณ WisePerks.com ไม่สามารถรับรองหรือรับประกันความปลอดภัยของข้อมูลใด ๆ ที่คุณส่งให้เราหรือจากผลิตภัณฑ์หรือบริการออนไลน์ของเราและคุณต้องเสี่ยงต่อตัวคุณเองเมื่อเราได้รับข้อมูลของคุณแล้วเราพยายามอย่างเต็มที่เพื่อรักษาความปลอดภัยให้กับระบบของเรา",

  "privacypolicy_topic9" : "ฉันควรรู้อะไรบ้างเกี่ยวกับความเป็นส่วนตัวของฉัน",
  "privacypolicy_topic9ans" : "โปรดจำไว้ว่าทุกครั้งที่คุณเลือกที่จะเปิดเผยข้อมูลส่วนบุคคลทางออนไลน์เช่นผ่านทางอีเมลเว็บไซต์เครือข่ายสังคมบล็อกหรือในพื้นที่แชทผู้ใช้รายอื่น ๆ สามารถรวบรวมและใช้ข้อมูลดังกล่าวได้หากคุณโพสต์ข้อมูลส่วนบุคคลออนไลน์ที่สามารถเข้าถึงได้โดยทั่วไปคุณอาจได้รับข้อความที่ไม่พึงประสงค์จากบุคคลอื่นในทางกลับกันท้ายที่สุดคุณจะต้องรับผิดชอบต่อการรักษาความลับของรหัสผ่านและ / หรือข้อมูลบัญชีของคุณโปรดระมัดระวังและรับผิดชอบเมื่อใดก็ตามที่คุณออนไลน์",

  "privacypolicy_topic10" : "WisePerks.com ปกป้องข้อมูลส่วนบุคคลของบุตรหลานของฉันอย่างไร?",
  "privacypolicy_topic10ans" : "WisePerks.com ได้รับความยินยอมจากผู้ปกครองก่อนที่การสำรวจต้องการให้เด็ก ๆ มีส่วนร่วมและต้องมีการดูแลผู้ปกครองด้วยเช่นกันสำหรับเด็กอายุ 6-15 ปีเราขอเอาใจใส่เป็นพิเศษในการปกป้องความปลอดภัยและความเป็นส่วนตัวของผู้ใช้วัยหนุ่มสาวในไซต์ของเราและเราสนับสนุนให้คุณเข้าร่วมประสบการณ์ออนไลน์ของบุตรหลานของคุณเราไม่อนุญาตให้มีการตลาดหรือในงานวิจัยสำหรับเด็กและหัวข้อบางอย่างต้องห้ามอย่างสมบูรณ์ในการวิจัยในหมู่เด็ก: ชื่อ / ชื่อบัญชี / อีเมลหรือที่อยู่ทางกายภาพหมายเลขโทรศัพท์เชื้อชาติหรือชาติพันธุ์ศาสนาหรือนักแสดงรายได้ในครอบครัวการเจ็บป่วยในครอบครัว , สถานภาพสมรสของบิดามารดาหรือสมาชิกในครอบครัวความสัมพันธ์เรื่องคะแนนในโรงเรียนหรือวิทยาลัยแอลกอฮอล์ปัญหาทางเพศยาสูบและอาวุธปืน",

  "privacypolicy_topic11" : "หมายเหตุพิเศษสำหรับผู้ใช้สากล",
  "privacypolicy_topic11ansp1" : "ไซต์นี้โฮสต์อยู่ในประเทศสหรัฐอเมริกาหากคุณเป็นผู้ใช้ที่เข้าถึงไซต์จากสหภาพยุโรปเอเชียหรือประเทศอื่นใดที่มีกฎหมายหรือข้อกำหนดเกี่ยวกับการเก็บรวบรวมการใช้และการเปิดเผยข้อมูลส่วนบุคคลที่แตกต่างจากกฎหมายของสหรัฐอเมริกาโปรดทราบว่าคุณกำลังถ่ายโอนข้อมูลส่วนบุคคลของคุณไปที่ สหรัฐอเมริกาที่ไม่มีกฎหมายคุ้มครองข้อมูลเช่นเดียวกับสหภาพยุโรปและภูมิภาคอื่น ๆ และโดยการให้ข้อมูลส่วนบุคคลของคุณคุณยินยอมที่จะ:",
  "privacypolicy_topic11ansp2" : "การใช้ข้อมูลส่วนบุคคลของคุณสำหรับการใช้งานที่ระบุไว้ด้านบนตามนโยบายส่วนบุคคล และการถ่ายโอนข้อมูลส่วนบุคคลของคุณไปยังประเทศสหรัฐอเมริกาตามที่ระบุข้างต้นคุณรับทราบว่ากฎหมายของประเทศสหรัฐอเมริกาสามารถใช้ข้อมูลของคุณในลักษณะที่อาจแตกต่างจากและน้อยกว่าการป้องกันการบำบัดที่จำเป็นต้องใช้ภายใต้กฎหมายของประเทศและเขตอำนาจศาลอื่น ๆหากคุณไม่ต้องการให้ข้อมูลของคุณถูกโอนไปยังประเทศสหรัฐอเมริกาคุณไม่ควรแบ่งปันข้อมูลของคุณกับเราหรือใช้เว็บไซต์นี้ในส่วนที่ได้รับอนุญาตตามกฎหมายของประเทศที่คุณตั้งอยู่คุณเห็นด้วยอย่างยิ่งว่าคุณต้องการให้สิทธิใด ๆ ที่คุณอาจต้องขอรับการรักษาข้อมูลการระบุข้อมูลของคุณตามกฎหมายของประเทศหรือเขตอำนาจศาลใด ๆ นอกเหนือจากประเทศสหรัฐอเมริกาอย่างไรก็ตามผู้ที่รอการตัดบัญชีอาจไม่ผูกมัดตามกฎหมายในบางประเทศเช่นประเทศสมาชิกของสหภาพยุโรปในขอบเขตที่ไม่ผูกมัดตามกฎหมายในประเทศที่คุณตั้งอยู่การขอผ่อนผันต่อไปนี้จะไม่ใช้กับคุณ",

  "privacypolicy_topic12" : "การเปลี่ยนแปลงและการปรับปรุงนโยบายความเป็นส่วนตัวนี้",
  "privacypolicy_topic12ans" : "WiseWorks ขอสงวนสิทธิ์ในการเปลี่ยนแปลงแก้ไขเพิ่มหรือลบบางส่วนของนโยบายความเป็นส่วนตัวเมื่อใดก็ได้ไม่ว่าจะด้วยเหตุใดก็ตามทุกครั้งที่ WiseWorks ใช้สิทธิดังกล่าวคุณจะต้องยอมรับนโยบายความเป็นส่วนตัวฉบับปรับปรุงใหม่และถ้าคุณไม่ทำเช่นนี้คุณจะไม่สามารถเข้าถึงหรือใช้ไซต์ได้อีกต่อไป",

  "privacypolicy_addinfo" : "ข้อมูลเพิ่มเติม",
  "privacypolicy_sentto" : "คำถามอื่น ๆ เกี่ยวกับเรื่องนี้ควรถูกส่งไปที่",

  "faq_faq" : "คำถามที่พบบ่อย",
  "faq_getans" : "รับคำตอบสำหรับคำถามทั้งหมดของคุณ",

  "faq_ques1" : "WisePerks คืออะไร?",
  "faq_ans1" : "เราดีใจที่คุณถามWisePerks เป็นเว็บไซต์สำรวจออนไลน์แบรนด์และ บริษัท ต่างๆกำลังมองหาผู้ตอบเพื่อแสดงความคิดเห็นและรับรางวัลตอบแทนWisePerks เป็นหนึ่งในแพลตฟอร์มดังกล่าวที่คุณสามารถให้ความคิดเห็นของคุณและได้รับรางวัลสำหรับมันเกินไป",

  "faq_ques2" : "เป็นอิสระที่จะเข้าร่วม?",
  "faq_ans2" : "ใช่มีอิสระที่จะเข้าร่วมในความเป็นจริงถ้ามีคนถามคุณค่าธรรมเนียมการเข้าร่วมเราต้องการให้คุณรายงานให้เราทราบ",

  "faq_ques3" : "ฉันสามารถดูเพื่อนของฉันได้หรือไม่?",
  "faq_ans3" : 'ใช่คุณสามารถเชิญเพื่อนและเพื่อนร่วมงานให้เข้าร่วมและได้รับรางวัลด้วย กรุณาคลิกที่ลิงค์ "แนะนำเพื่อน" ที่แผงควบคุมเพื่อรับรายละเอียดทั้งหมด',

  "faq_ques4" : "ฉันจะได้รับรายได้อะไร?",
  "faq_ans4" : "ตอนนี้ในรูปแบบใหม่ของเรา, คุณสามารถได้รับคะแนนในหลายวิธีอื่นนอกเหนือจากการสำรวจ. คุณได้รับคะแนนโดย: การลงทะเบียนกับเรา, โดยการยืนยันบัญชีอีเมลของคุณ, สำหรับการกรอกข้อมูลส่วนตัวของคุณ, แน่นอนสำหรับการสำรวจใดๆและให้ความประหลาดใจของคุณแม้จะมีการสำรวจที่ถูกตัดสิทธิ์. ดังนั้นเราจึงมีเหตุผลทั้งหมดที่จะได้รับคุณเริ่มต้นไม่ได้?",

  "faq_ques5" : "ฉันจะเป็นสมาชิก WisePerks.com ได้อย่างไร?",
  "faq_ans5" : 'เปิด WisePerks.com บนเบราเซอร์ของคุณสร้างการเข้าสู่ระบบสมาชิกโดยคลิกที่แท็บ "ลงทะเบียน"เพียงทำตามขั้นตอนและจะแนะนำคุณตลอดขั้นตอนที่เหลือคุณจะต้องยืนยันเจตนารมณ์ในการเข้าร่วมโดยคลิกที่อีเมลยืนยันที่เราส่งมาจากอีเมลของคุณ',

  "faq_ques6" : "อีเมลยืนยันที่คุณกล่าวถึงอยู่ที่ไหน?",
  "faq_ans6p1" : "อีเมลยืนยันจะถูกส่งไปยังที่อยู่อีเมลที่คุณให้โดยอัตโนมัติเมื่อลงชื่อสมัครใช้ หากคุณไม่เห็นอีเมลในกล่องจดหมายโปรดตรวจสอบสแปมหรือโฟลเดอร์ขยะของคุณ เพื่อหลีกเลี่ยงอีเมล์ใดๆในอนาคตจากเราและการสำรวจคำเชิญ/ข้อความจากการเข้าถึงโฟลเดอร์สแปมของคุณโปรดทำการเพิ่ม",
  "faq_ans6p2" : "ไปยังรายชื่อผู้ส่งที่ได้รับอนุญาตหรือเป็นที่ติดต่อในกล่องจดหมายของคุณ หากคุณยังไม่พบอีเมลยืนยันโปรดลงชื่อเข้าใช้บัญชีของฉันเพื่อยืนยันว่าที่อยู่อีเมลของคุณกับเราถูกต้องและขออีเมลยืนยันอีกครั้ง",

  "faq_ques7" : "ฉันจะสำรวจได้อย่างไร?",
  "faq_ans7" : 'เมื่อคุณเข้าสู่ระบบหลังจากป้อนชื่อผู้ใช้และรหัสผ่านของคุณแล้วคุณจะเข้าถึงแดชบอร์ดของคุณและสามารถดูแบบสำรวจทั้งหมดที่คุณสามารถทำได้ เรายังส่งลิงก์แบบสำรวจไปยังอีเมลที่คุณลงทะเบียนไว้ด้วย คุณสามารถใช้การเชื่อมโยงโดยตรงจากกล่องจดหมายของคุณ',

  "faq_ques8" : "ข้อมูลของฉันเป็นความลับอย่างไร?",
  "faq_ans8" : "สำหรับ WisePerks การรักษาความเป็นส่วนตัวและความลับของผู้ใช้ถือเป็นเรื่องสำคัญที่สุดลูกค้าของเราสนใจเฉพาะสิ่งที่คุณคิดว่าเป็นผู้บริโภคหรือคุณรู้สึกอย่างไรเกี่ยวกับบางสิ่งบางอย่างเราที่ WisePerks ไม่เคยแบ่งปัน / ส่งต่อข้อมูลส่วนบุคคลใด ๆ ให้กับลูกค้าของเราและไม่มีการสำรวจ WisePerks ยังไม่ขายหรือให้เช่าข้อมูลใด ๆ แก่บุคคลที่สาม",

  "faq_ques9" : "การสำรวจเหล่านี้นานแค่ไหน?",
  "faq_ans9" : "การสำรวจส่วนใหญ่ใช้เวลาเพียง 10 ถึง 15 นาทีหรือแม้แต่น้อยอย่างไรก็ตามบางครั้งเราอาจมีการสำรวจอีกต่อไปด้วยการสำรวจแต่ละครั้งเราจะแจ้งให้คุณทราบล่วงหน้าเป็นระยะเวลานานเท่าใด แต่โปรดอย่าลืมว่าการสำรวจอีกต่อไปจะมีผลตอบแทนสูงเช่นกัน",

  "faq_ques10" : "ทุกคนสามารถใช้การสำรวจ WisePerks ได้หรือไม่?",
  "faq_ans10" : "คุณต้องมีอายุ 13 ปีขึ้นไปในการลงทะเบียนกับ WisePerksแม้ว่าบางครั้งเราจะเชิญคุณเข้าร่วมการสำรวจเพื่อเข้าร่วมกับสมาชิกที่อายุน้อยกว่าในครอบครัวของคุณ",

  "faq_ques11" : "คุณรู้ได้อย่างไรว่าฉันจะมีสิทธิ์ได้รับการสำรวจ?",
  "faq_ans11" : "อัลกอริทึมของเราตรงกับข้อมูลโปรไฟล์ของคุณพร้อมแบบสำรวจที่พร้อมใช้งานเพื่อให้แน่ใจว่าคุณจะได้รับการสำรวจที่เหมาะสมที่สุดเมื่อการสำรวจเริ่มขึ้นคำถามแรก ๆ จะระบุว่าคุณเป็นผู้ถูกร้องเรียนหรือไม่ว่าลูกค้าของเรากำลังมองหาแบบสอบถามนั้นเรามีการสำรวจจำนวนมากที่กำลังมองหาผู้คนจำนวนมาก (เช่นผู้ที่ดูภาพยนตร์เป็นประจำเล่นกีฬาโดยเฉพาะผู้หญิงที่มีบุตร ฯลฯ ) และการสำรวจใหม่ ๆ เกิดขึ้นทุกวัน!",

  "faq_ques12" : "อะไรคือข้อผูกพันของฉันกับ WisePerks?",
  "faq_ans12" : "สิ่งเดียวที่เราคาดหวังจากคุณคือการให้ความคิดเห็นและความคิดของคุณอย่างสุจริตเนื่องจากลูกค้ากำลังมองหาคำตอบที่ซื่อสัตย์และเป็นจริงเพื่อปรับปรุงผลิตภัณฑ์และบริการของตนโปรดระบุข้อมูลที่ถูกต้องเมื่อลงชื่อสมัครเป็นสมาชิกและทำการปรับปรุงการเปลี่ยนแปลงตามที่เกิดขึ้น",

  "faq_ques13" : "เหตุใดฉันจึงควรให้ข้อมูลเกี่ยวกับครัวเรือนเทคโนโลยีหรือผลิตภัณฑ์ที่ฉันซื้อ",
  "faq_ans13" : "สำหรับการสำรวจแต่ละครั้งเรากำลังมองหารายละเอียดบางอย่างของผู้ตอบแบบสอบถามถ้าเรารู้จากข้อมูลโปรไฟล์ของคุณว่าข้อมูลของคุณตรงกับความต้องการของลูกค้าบิงโก!เราเกือบจะมั่นใจได้ว่าคุณจะสามารถทำแบบสำรวจได้สำเร็จและได้รับรางวัลสำหรับสิ่งนี้นี้โดยทั่วไปจะเพิ่มโอกาสในการเลือกสำหรับการสำรวจ",

  "faq_ques14" : "เมื่อไหร่ที่ฉันจะได้รับบัตรของขวัญหลังจากเสร็จสิ้นการสำรวจ WisePerks?",
  "faq_ans14" : "คะแนนที่คุณได้รับหลังจากเสร็จสิ้นการสำรวจจะถูกสะสมในถังของคุณ เมื่อจุดเหล่านี้จะช่วยให้คุณสามารถแลกสิทธิ์",

  "faq_ques15" : "บัญชีของฉันคืออะไร?",
  "faq_ans15" : "เป็นเพียงวิธีที่ง่ายสำหรับคุณในการดูข้อมูลส่วนตัวของคุณทำการเปลี่ยนแปลงตามที่ต้องการดูกิจกรรมการสำรวจผลตอบแทนที่ได้รับทุกอย่างในที่เดียว",

  "faq_ques16" : "ฉันจะยกเลิกบัญชีของฉันได้อย่างไร?",
  "faq_ans16" : "เรามั่นใจว่าคุณจะไม่ต้องการทำเช่นนี้ อย่างไรก็ตามบนหน้าแดชบอร์ดของคุณ--> ไปที่การตั้งค่า--> จัดการบัญชี--> ยกเลิกการใช้บัญชี",

  "faq_ques17" : "ระบบจุดทำงานอย่างไร?",
  "faq_ans17p1" : "แต่ละแบบสำรวจมีไว้สำหรับคะแนนที่แน่นอน หลังจากเสร็จสิ้นการสำรวจคะแนนเหล่านี้จะถูกเพิ่มไปยังรายได้ของคุณ คุณสามารถแลกได้เมื่อถึงเกณฑ์ขั้นต่ำ",
  "faq_ans17p2" : "ในบางกรณีเนื่องจากความท้าทายที่ไม่คาดฝันบางอย่างกับการเชื่อมต่อหรือการแยกย่อยการตอบสนองของคุณอาจไม่ได้รับการบันทึกในตอนท้ายของลูกค้าของเรา จากนั้นเราจะต้องย้อนกลับคะแนนเหล่านั้นออกจากบัญชีของคุณ หากคุณแลกคะแนนเหล่านี้แล้วและบัญชีของคุณมียอดเงินคงเหลือต่ำรายได้ของคุณจะเป็นลบ การปรับเหล่านี้จะเกิดขึ้นในรอบการแลกใช้ครั้งต่อไปของคุณ",

  "faq_ques18" : "คะแนนสำหรับแบบสำรวจจะเพิ่มคะแนนสะสมของฉันในระยะเวลาเท่าไร?",
  "faq_ans18" : "คะแนนของคุณจะถูกเพิ่มเข้าไปในยอดคะแนนของคุณภายใน 48 ชั่วโมง",

  "faq_ques19" : "เกณฑ์ขั้นต่ำสำหรับการไถ่ถอนคืออะไร?",
  "faq_ans19" : "เกณฑ์ขั้นต่ำสำหรับการไถ่ถอนคือ 25000 คะแนนโดยเฉลี่ยคุณจะต้องทำแบบสำรวจ 8-12 เพื่อให้มีสิทธิ์ได้รับการไถ่ถอน",

  "faq_ques20" : "คะแนนสะสมได้รับการแปลงเป็นบัตรเงินสดด้วยวิธีใด?มีอัตราส่วนหรือไม่?",
  "faq_ans20" : "ใช่. คะแนนสะสมได้รับการแปลงเป็นเงินสดบัตรของขวัญทั้งนี้ขึ้นอยู่กับประเทศของคุณอัตราส่วนการแปลงเป็นดังที่แสดงด้านล่าง",
  "faq_ponits" : "จุด",
  "faq_point" : "จุด",
  "faq_cent" : "ร้อย",

  "faq_ques21" : "ยังมีคำถามเพิ่มเติมหรือไม่?",
  "faq_ans21p1" : "รู้สึกฟรีที่จะส่งอีเมลหาเราที่",
  "faq_ans21p2" : "และเราจะได้รับกลับมาให้คุณภายใน๔๘ชั่วโมง.",

  "Profiling_profiledashboard" : "แดชบอร์ดของโปรไฟล์", 
  "Profiling_completeprofile" : "กรอกข้อมูลในโปรไฟล์ของคุณและรับ",
  "Profiling_completepoints" : "จุด!",
  "Profiling_answercarefully" : "ชุดคำถามทั่วไปต่อไปนี้จะถูกใช้เพื่อสร้างโปรไฟล์ส่วนตัวของคุณเพื่อให้คุณมีโอกาสในการสำรวจในอนาคตที่ดีที่สุด กรุณาใช้เวลาของคุณตอบอย่างรอบคอบและดีๆ",

  "Profiling_cat_general" : "ทั่ว ไป",
  "Profiling_cat_personal" : "ส่วน บุคคล",
  "Profiling_cat_household" : "บ้าน",
  "Profiling_cat_profession" : "อาชีพ",

  "Profiling_bar_completed" : "% เสร็จสมบูรณ์",
  
   "Profiling_update_ans_button" : "อัปเดต & ดำเนินการต่อ",
  "Profiling_save_ans_button" : "บันทึก",
  "Profiling_sc_ans_button" : "บันทึกและดำเนินการต่อ",

  "Category_thanku_msg1" : "ดีไป",
  "Category_thanku_msg2" : "อีกไม่กี่และคุณจะมี",
  "Category_thanku_msg3" : "จุดในบัญชีของคุณ",

  "Category_thanku_update_msg1" : "ขอบคุณสำหรับการปรับปรุงข้อมูลของคุณ!",
  "Category_thanku_update_msg2" : "",
  "Category_thanku_update_msg3" : "",
  "Category_Continue_button" : "ดำเนิน",

  "OverAll_thanku_msg1" : "ขอบคุณสำหรับการแบ่งปันข้อมูลของคุณ. คุณได้รับ",
  "OverAll_thanku_msg2" : "จุด",

  "Survey_history_surveyhistory" : "ประวัติการสำรวจ",
  "Survey_history_fromthisscreen" : "จากหน้าจอนี้คุณจะเห็นธุรกรรมทั้งหมดของคุณ",
  "Survey_history_show" : "แสดง",
  "Survey_history_entries" : "รายการ",
  "Survey_history_date" : "วัน",
  "Survey_history_details" : "ราย ละเอียด",
  "Survey_history_surveys" : "สำรวจ",
  "Survey_history_pointsreceived" : "คะแนนที่ได้รับ",
  "Survey_history_result" : "ผล",
  "Survey_history_status" : "สถานะ",
  "Survey_history_status_complete" : "เสร็จ สมบูรณ์",
  "Survey_history_status_disqualified" : "ตัด", 
  "Survey_history_keyword" : "คำ",
  "Survey_history_search" : "ค้น หา",
  "Survey_history_to" : "ถึง",
  "Survey_history_selectoption" : "เลือกตัวเลือก",
  "Survey_history_earned" : "รับ",
  "Survey_history_redeemed" : "แลก",
  "Survey_history_norecord" : "ไม่พบเรกคอร์ด",
  "Survey_history_Surveypts" : "จุดสำรวจ",
  "Survey_history_Promocode" : "รหัสโปรโมชั่น",

  "My_transactions_mytransactions" : "ธุรกรรมของฉัน",
  "My_transactions_fromthisscreen" : "จากหน้าจอนี้คุณจะเห็นธุรกรรมทั้งหมดของคุณ",
  "My_transactions_show" : "แสดง",
  "My_transactions_entries" : "รายการ",
  "My_transactions_transactionid" : "รหัสธุรกรรม",
  "My_transactions_date" : "วัน",
  "My_transactions_details" : "ราย ละเอียด",
  "My_transactions_points" : "จุด",
  "My_transactions_status" : "สถานะ",
  "My_transactions_keyword" : "คำ",
  "My_transactions_search" : "ค้น หา",
  "My_transactions_to" : "ถึง",
  "My_transactions_selectoption" : "เลือกตัวเลือก",
  "My_transactions_status_earned" : "รับ",
  "My_transactions_status_redeemed" : "แลก",
  "My_transactions_status_pending" : "รอ",
  "My_transactions_status_reverted" : "แปลงกลับ",
  "My_transactions_status_declined" : "ปฏิเสธ",
  "My_transactions_norecord" : "ไม่พบเรกคอร์ด",
  "My_transactions_off_msg1" : "หลังจาก ",
  "My_transactions_off_msg2" : ", รายละเอียดการทำธุรกรรมทั้งหมดของคุณจะถูกเผยแพร่ในแท็บหนังสือคะแนน",

  "Passbook_heading" : "คะแนนสะสม",
  "Passbook_show" : "แสดง",
  "Passbook_entries" : "รายการ",
  "Passbook_search" : "ค้นหา",
  "Passbook_type" : "ชนิด",
  "Passbook_surveyid" : "การสำรวจ",
  "Passbook_date" : "วันที่",
  "Passbook_selectoption" : "เลือกตัวเลือก",
  "Passbook_credit" : "เครดิต",
  "Passbook_debit" : "หักบัญชี",
  "Passbook_survey_id" : "รหัสแบบสำรวจ",
  "Passbook_survey_pts" : "จุดสำรวจ",
  "Passbook_earned_pts" : "จุด",
  "Passbook_pending_pts" : "คะแนนที่รออนุมัติ",
  "Passbook_promo_code" : "รหัสโปรโมชั่น",
  "Passbook_transaction_type" : "ประเภทธุรกรรม",
  "Passbook_balance" : "สมดุล",
  "Passbook_status" : "สถานะ",
  "Passbook_type_soi" : "การลงทะเบียน",
  "Passbook_type_doi" : "การยืนยันอีเมล",
  "Passbook_type_profile" : "เสร็จสิ้นโปรไฟล์",
  "Passbook_type_survey" : "สำรวจ",
  "Passbook_type_doir" : "ตรวจสอบอีเมลโดย",
  "Passbook_type_doirt" : "การตรวจสอบอีเมลโดยการอ้างอิง",
  "Passbook_type_surveyr" : "สำรวจความพยายามโดย",
  "Passbook_type_surveyrt" : "สำรวจความพยายามโดยการอ้างอิง",
  "Passbook_type_reward" : "รางวัล",
  "Passbook_type_pending" : "การปรับ",
  "Passbook_type_reverted" : "คะแนนย้อนกลับ",
  "Passbook_type_declined" : "คำขอถูกปฏิเสธ",
  "Passbook_type_redeem" : "ไถ่ถอน",
  "Passbook_type_balance" : "ดำเนินการส่งต่อ",
  "Passbook_balance_vary" : "ยอดคงเหลือจริงอาจแตกต่างกันไป",
  "Passbook_survey_debit_reason" : "เราให้ความสำคัญกับความพยายามของคุณ อย่างไรก็ตามเนื่องจากการเชื่อมต่อที่ไม่สามารถควบคุมได้ลดลงในขณะที่การถ่ายโอนข้อมูลของคุณไม่สามารถลงทะเบียนได้ เราจะต้องย้อนกลับคะแนนที่คุณได้รับก่อนหน้านี้สำหรับแบบสำรวจนี้ ขออภัยในความไม่สะดวกที่เกิดขึ้น",

  "Redeem_redeemed" : "แลก",
  "Redeem_redeemhistory" : "แลกรับประวัติ",
  "Redeem_history_norecord" : "ไม่พบเรกคอร์ด",
  "Redeem_date" : "วัน",
  "Redeem_details" : "ราย ละเอียด",
  "Redeem_points" : "จุด",
  "Redeem_status" : "สถานะ",
  "Redeem_lookslike" : "ดูเหมือนว่าคุณพลาดการยืนยันบัญชีอีเมลของคุณ",
  "Redeem_hurry" : "รีบ! คุณได้รับ๑๐๐๐จุดเมื่อคุณตรวจสอบ",
  "Redeem_pleasecheck" : "กรุณาตรวจสอบกล่องขาเข้าของคุณและคลิกลิงก์ในอีเมลยืนยันที่ส่งเพื่อเปิดใช้งานบัญชีของคุณ",
  "Redeem_kindlycheck" : "กรุณาตรวจสอบสแปม/ขยะโฟลเดอร์ของคุณเช่นกันสำหรับอีเมลยืนยัน",
  "Redeem_getconfirmationemail" : "ยังไม่ได้รับอีเมลยืนยัน?",
  "Redeem_resendconfirmationemail" : "ส่งอีเมลยืนยันอีกครั้ง",
  "Redeem_rewardredemptionrule" : "กฎการแลกของรางวัล",
  "Redeem_completesurvey" : "แบบสำรวจที่สมบูรณ์",
  "Redeem_earnpoints" : "สะสมคะแนน",
  "Redeem_redeemrewards" : "แลกรางวัล",
  "Redeem_note" : "หมาย เหตุ:",
  "Redeem_yourearnedpoints" : "คะแนนที่ได้รับของคุณจะกลายเป็นแลกเปลี่ยนหลังจากที่ได้รับการคัดเลือก ในการแลกรางวัลจะต้องมีคะแนนสะสมขั้นต่ำในบัญชีของคุณ",
  "Redeem__points" : "จุด",
  "Redeem_availablebalance" : "สมดุลที่มีจำหน่าย:",
  "Redeem_historydetails" : "คลิกที่นี่เพื่อดูรายละเอียดประวัติการแลกของคุณ", 
  "Redeem_reqsucc" : "ยินดี ! คะแนนของคุณได้รับการแลก กรุณาตรวจสอบรายละเอียดเพิ่มเติมในกล่องจดหมายที่ลงทะเบียนไว้", 
  "Redeem_wisecheck_youhave" : "ขอแสดงความยินดี! คุณเป็นเพียงคลิกเดียวจากรางวัลของคุณ",
  "Redeem_wisecheck_gcagainst" : "บัตรของขวัญ",
  "Redeem_wisecheck_points" : "จุด",
  "Redeem_wisecheck_issue" : "ระบบได้จับกิจกรรมบางอย่างที่ไม่รู้จักในบัญชีของคุณเนื่องจากคุณไม่สามารถส่งคำขอแลกสิทธิ์ได้ กรุณาติดต่อที่",
  "Redeem_emailverify_issue" : "เพื่อแลกคะแนนของคุณเราจะขอให้คุณยืนยันบัญชีอีเมลที่ลงทะเบียนของคุณ",

  "Redeem_unsubscribe_issue" : "คุณไม่สามารถส่งคำขอแลกเนื่องจากคุณยกเลิกการสมัครจาก WisePerks โปรดติดต่อ support@wiseperks.com เพื่อสมัครสมาชิกอีกครั้ง",
  "Redeem_wisecheck_message1" : "คุณไม่สามารถไถ่ถอนได้เนื่องจากเหตุผลด้านความปลอดภัยบางประการ กรุณาติดต่อเพื่อขอความช่วยเหลือ",
  "Redeem_wisecheck_message2" : ".",
  "Redeem_Confirm_button" : "ยืนยัน",
  "Redeem_Cancel_button" : "ยกเลิก",
  "Redeem_pending_hello" : "สวัสดี",
  "Redeem_pending" : "การปรับ",
  "Redeem_pending_msg1" : "บัญชีของคุณแสดงการปรับ",
  "Redeem_pending_msg2" : "คะแนนที่จะดำเนินการ โปรดยืนยันเพื่อเริ่มต้นการทำธุรกรรม",

  "Dashboard_wisecheck_issue" : "ระบบได้บันทึกกิจกรรมที่ไม่รู้จักในบัญชีของคุณเนื่องจากคุณไม่สามารถดูแบบสำรวจได้ กรุณาติดต่อ support@wiseperks.com เพื่อขอความกระจ่างเพิ่มเติม",
  "Dashboard_unsubscribe_issue" : "คุณไม่สามารถดูแบบสำรวจใด ๆ เนื่องจากคุณยกเลิกการสมัครจาก WisePerks กรุณาติดต่อ support@wiseperks.com เพื่อรับแบบสำรวจอีกครั้ง",


  "WC_DashboardMsg_1" : "อ๊ะ! ไม่มีการสำรวจเพื่อให้ตรงกับโปรไฟล์ของคุณ ณ ขณะนี้",
  "WC_DashboardSubMsg_1" : "ไม่ต้องกังวลเราจะสับสินค้าคงคลังของเราและจะส่งแบบสำรวจใหม่ ๆ ในแบบของคุณเร็ว ๆ นี้",

  "WC_DashboardMsg_2" : "เรากำลังรีเฟรชหน้าแดชบอร์ดของคุณ โปรดตรวจสอบการสำรวจใหม่หลังจากที่บางครั้ง",
  "WC_DashboardSubMsg_2" : "",

  "Survey_success_msg1" : "ขอบคุณสำหรับการสำรวจเสร็จสมบูรณ์. คุณเพิ่งได้รับresponse_pointsแต้ม. ล็อกอินเข้าสู่หน้าแดชบอร์ดเพื่อดูคะแนนสะสมทั้งหมดของคุณ",
   "Survey_success_msg2" : "ขอบคุณสำหรับการสำรวจเสร็จสมบูรณ์. คุณเพิ่งได้รับ response_points จุด.",

  "Survey_success_but_nomore_survey" : "ยินดี ! คุณเพิ่งได้รับ response_points คะแนนสำหรับการทำแบบสำรวจเสร็จสมบูรณ์ กรุณาตรวจสอบการสำรวจที่จะเกิดขึ้นหลังจากที่บางครั้ง.",
  
  "Survey_terminate_pnt_msg1" : "ดูเหมือนว่าข้อมูลบางส่วนของคุณจะแตกต่างกันเล็กน้อยจากความต้องการ เราให้คุณค่ากับเวลาและความพยายามของคุณจะเพิ่มresponse_pointsชี้ไปที่บัญชีของคุณ เรามีความมุ่งมั่นที่จะนำคุณไปสู่การสำรวจที่ใช้งานง่ายมากขึ้น",
  
  "Survey_terminate_nopnt_msg1" : "ดูเหมือนว่าคำตอบบางข้อของคุณแตกต่างจากข้อกำหนดเล็กน้อย เราจะส่งการสำรวจเพิ่มเติมเพื่อคุณ ขอขอบคุณสำหรับเวลาและความพยายามของคุณ",

  "TermsConditions_t&c" : "เงื่อนไข",
  "TermsConditions_WhenRegister" : "เมื่อคุณลงทะเบียน",
  "TermsConditions_WhenYouCreate" : "เมื่อคุณสร้างบัญชีส่วนบุคคลเราจะขอข้อมูลส่วนบุคคลแก่คุณดังที่ได้กล่าวไว้ในที่นี้:",
  "TermsConditions_YouCanUpdate" : "คุณสามารถอัปเดตหรือเปลี่ยนข้อมูลโปรไฟล์พื้นฐานของคุณได้ตลอดเวลา",
  "TermsConditions_YouCanOptOut" : "คุณสามารถเลือกไม่ใช้หรือปิดบัญชีของคุณได้ตลอดเวลา",
  "TermsConditions_WeRespectYour" : "เราเคารพในความเป็นส่วนตัวของคุณและใช้เทคโนโลยีที่ดีที่สุดในการปกป้องข้อมูลของคุณอย่างปลอดภัยจากการเข้าถึงทางกายภาพและทางอิเล็กทรอนิกส์โดยไม่ได้รับอนุญาต",
  "TermsConditions_WeShareYour" : "เราแบ่งปันข้อมูลของคุณกับองค์กรเท่านั้นซึ่งจำเป็นต้องใช้งาน WiseWorks และองค์กรเหล่านี้จำเป็นต้องดูแลความรับผิดชอบต่อข้อมูลส่วนบุคคลและความปลอดภัยของคุณ",
  "TermsConditions_WhatInformation" : "ข้อมูลใดที่เราเก็บรวบรวมจากคุณ",
  "TermsConditions_DirectlyCollected" : "เก็บรวบรวมโดยตรง",
  "TermsConditions_EmailAddressAndPassword" : "ที่อยู่อีเมลและรหัสผ่านของบัญชีของคุณกับเรา",
  "TermsConditions_YourResponse" : "การตอบกลับของคุณต่อคำถามเกี่ยวกับการจัดรูปแบบ",
  "TermsConditions_AnyCustomer" : "จดหมายบริการลูกค้าสัมพันธ์",
  "TermsConditions_AnyPersonalDetails" : "รายละเอียดส่วนบุคคลที่คุณแชร์เพื่อแลกรับ",
  "TermsConditions_AnyOtherInformation" : "ข้อมูลอื่น ๆ ที่คุณให้โดยตรง",
  "TermsConditions_UsageData" : "ข้อมูลการใช้งาน",
  "TermsConditions_YourIPAddress" : "ที่อยู่ IP ตำแหน่งทางภูมิศาสตร์และคุกกี้ของคุณ",
  "TermsConditions_InformationAboutTheDevice" : "ข้อมูลเกี่ยวกับอุปกรณ์ที่คุณใช้",
  "TermsConditions_YourSurveyActivity" : "กิจกรรมการสำรวจของคุณชี้ในบัญชีของคุณการชำระเงินที่คุณได้รับหลังการไถ่ถอน",
  "TermsConditions_HowDoWeUse" : "เราจะใช้ข้อมูลของคุณอย่างไร",
  "TermsConditions_SendingYouInvitation" : "ส่งอีเมลข้อความเชิญเพื่อตอบแบบสำรวจที่คุณมีคุณสมบัติ",
  "TermsConditions_DetectAndPrevent" : "ตรวจหาและป้องกันการฉ้อฉล",
  "TermsConditions_ImproveYourExperience" : "ปรับปรุงประสบการณ์ของคุณบนแพลตฟอร์ม WiseWorks",
  "TermsConditions_YourResponseAreTransferred" : "คำตอบของคุณจะถูกโอนไปยังบุคคลที่สามและพาร์ทเนอร์ในเครือในรูปแบบที่รวมและไม่ระบุ",
  "TermsConditions_OurPartnersCanAsk" : "พันธมิตรของเราสามารถขอให้คุณระบุชื่อที่อยู่อีเมลและข้อมูลการติดต่ออื่น ๆ ของคุณในระหว่างการสำรวจ",
  "TermsConditions_YouAreFreeToDecline" : "คุณมีอิสระที่จะปฏิเสธการให้รายละเอียดกับคู่ค้าของเราหากคุณยอมรับมากกว่าที่คุณให้ข้อมูลนี้โดยตรงกับพวกเขาและไม่ใช่ WiseWorks",
  "TermsConditions_YourInformationWillBe" : "ข้อมูลของคุณจะได้รับการจัดการตามนโยบายความเป็นส่วนตัวทางธุรกิจที่เกี่ยวข้องและไม่ใช่นโยบายความเป็นส่วนตัวของ WiseWorks",
  "TermsConditions_OurPartnersAreCommited" : "พันธมิตรของเรามุ่งมั่นที่จะเคารพและปกป้องข้อมูลส่วนบุคคลของคุณ",
  "TermsConditions_WhatWeDont" : "สิ่งที่เราไม่ได้ทำกับมัน",
  "TermsConditions_WeDontSellOnThat" : "เราไม่ได้ขายข้อมูลดังกล่าวให้กับทุกคนและเราไม่ได้ใช้เพื่อขายอะไรให้กับคุณ เราจะขออนุญาตก่อนที่จะแบ่งปันข้อมูลของคุณเสมอ",
  "TermsConditions_YourRightToControl" : "สิทธิ์ในการควบคุมข้อมูลของคุณ",
  "TermsConditions_YouHaveFullControl" : "คุณสามารถควบคุมข้อมูลได้เต็มรูปแบบ",
  "TermsConditions_YouCanAccess" : "คุณสามารถเข้าถึงอัปเดตหรือเปลี่ยนข้อมูลโปรไฟล์พื้นฐานได้ทุกเมื่อที่ต้องการ",
  "TermsConditions_YouCanUnsubscribe" : "คุณสามารถยกเลิกและยกเลิกการใช้งานบัญชีของคุณได้",
  "TermsConditions_YouAreFreeToGetYour" : "คุณสามารถลบโปรไฟล์ของคุณได้โดยส่งอีเมลมาที่ support@wiseperks.com เราจะพยายามแก้ไขปัญหาที่คุณกังวลและหากคุณยังต้องการลบบัญชีของคุณอยู่ให้ดำเนินการภายใน 72 ชั่วโมง",
  "TermsConditions_DataSecurity" : "การรักษาความปลอดภัยข้อมูล",
  "TermsConditions_OurTechTeamWorks" : "ทีมงานด้านเทคนิคของเราทำงานอย่างหนักเพื่อรักษาความปลอดภัยให้กับข้อมูลทั้งหมดของคุณ",
  "TermsConditions_WeMakeUseOfLatest" : "เราใช้เทคโนโลยีและมาตรการล่าสุดเพื่อหลีกเลี่ยงการใช้ข้อมูลที่ไม่ถูกต้องหรือการเข้าถึงข้อมูลโดยไม่ได้รับอนุญาต อย่างไรก็ตามเนื่องจากลักษณะของสภาพแวดล้อมออนไลน์เราจึงไม่สามารถรับประกันข้อมูลได้ 100%",
  "TermsConditions_WeTryOurBestToRule" : "เราพยายามอย่างดีที่สุดเพื่อขจัดความเสี่ยง แต่ไม่สามารถรับประกันสภาพแวดล้อมที่ปราศจากความเสี่ยงได้ เมื่อยอมรับข้อกำหนดและเงื่อนไขเหล่านี้คุณยอมรับและยอมรับความเสี่ยงเหล่านี้แล้ว",
  "TermsConditions_AnyQuestions" : "คำถามใด ๆ โปรดติดต่อเรา",
  "TermsConditions_IfYouHaveAnyQueries" : "หากคุณมีข้อสงสัยหรือข้อร้องเรียนเกี่ยวกับนโยบายและขั้นตอนการเก็บข้อมูลส่วนบุคคลของเรา โปรดส่งอีเมลมาที่ support@wiseperks.com และเราจะติดต่อกลับภายใน 48 ชั่วโมง",

  "Validation_PleaseEnterProperDate" : "โปรดป้อนวันเกิดที่ถูกต้อง",
  "Validation_PleaseSelectOne" : "กรุณาเลือกหนึ่งตัวเลือก!",
  "Validation_PleaseSelectValidOptions" : "กรุณาเลือกตัวเลือกที่ถูกต้อง!",
  "Validation_PleaseSelectAtLeaseOneOption" : "โปรดเลือกอย่างน้อยหนึ่งตัวเลือก",
  "Validation_PleaseInsertTheZip" : "โปรดใส่รหัสไปรษณีย์ / ไปรษณีย์",

  "Releases_releases" : "รุ่น",
  "Releases_theUseOfThis" : "การใช้เว็บไซต์นี้อยู่ภายใต้เงื่อนไขการใช้งานต่อไปนี้",
  "Releases_featuresOfWP" : "สิ่งอำนวยความสะดวกใน WP รุ่น",
  "Releases_updatedOn" : "ปรับปรุงบน",
  "Releases_WisePerksNow" : "WisePerks สนับสนุนหลายภาษา",
  "Releases_youCanWalkThourgh" : "คุณสามารถเดิน thourgh เว็บไซต์ที่มีความสะดวกสบายมากขึ้นในขณะนี้เป็น WisePerks ที่มีอยู่ในภาษา preffered ของคุณ.",
  "Releases_languagesAvailable" : "ภาษาที่ใช้ได้:",
  "Releases_EarnMore" : "รับข้อมูลเพิ่มเติมด้วยระบบจุดใหม่ของเรา",
  "Releases_theNewWisePerksAccumulates" : "WisePerks ใหม่จะสะสมคะแนนลงในบัญชีของคุณ จุดเหล่านี้ถือเป็นค่าที่สูงกว่ามากและง่ายต่อการได้รับและแลก เรามั่นใจว่าคุณจะเพลิดเพลินกับการสำรวจประสบการณ์ที่มีหลายตัวเลือก",
  "Releases_accumulatePoints" : "สะสมคะแนนกับ hassel ฟรี redeemption",
  "Releases_youGetTheBenefit" : "คุณจะได้รับประโยชน์ของรายได้ที่เหมือนกัน โดยไม่คำนึงถึงสกุลเงินที่คุณต้องการใช้ในการแลกคะแนน",
  "Releases_surveyDisqualification" : "ไม่มีข่าวร้าย",
  "Releases_youEarnPoints" : "คุณจะได้รับคะแนนแม้ในขณะที่คุณไม่ได้มีคุณสมบัติในการสำรวจคุณเริ่มตอบ",
  "Releases_newAndImproved" : "รูปแบบใหม่และการปรับปรุง",
  "Releases_theFreshLookOf" : "รูปลักษณ์ใหม่ของ WisePerks จะทำให้คุณตกหลุมรักกับมัน. ตอนนี้มันง่ายมากที่จะใช้และจะเป็นประสบการณ์ที่ดีสำหรับคุณ.",
  "Releases_whatAvatarAreYouToday" : "คุณเป็นใครกันในวันนี้",
  "Releases_youCanNowCreate" : "ขณะนี้คุณสามารถสร้าง avatar ของคุณเองในหน้าแดชบอร์ดได้",
  "Releases_freshAndHotSurveys" : "การสำรวจความสดใหม่และความร้อนบนแผงควบคุมของคุณ",
  "Releases_youDontHaveTo" : "คุณไม่ต้องกังวลเกี่ยวกับ refresing แดชบอร์ดของคุณเพื่อดูแบบสำรวจใหม่เราจะเก็บแดชบอร์ดของคุณให้มีการสร้างแบบสำรวจล่าสุดโดยอัตโนมัติ",
  "Releases_promoCode" : "คุณสมบัติรหัสโปรโมชั่น",
  "Releases_promoCodeInfo" : "ตามความต้องการที่เป็นที่นิยม WisePerks นำรหัสโปรโมชั่นสำหรับผู้ทดสอบชิมทุกสัปดาห์ วิธีที่รวดเร็วเพื่อคว้ารางวัลเพิ่มเติม",
  "Releases_referFriend" : "แนะนำเพื่อน",
  "Releases_referFriendInfo" : "ให้เพื่อนของคุณเชื่อมโยงกับ WisePerks และรับรางวัลที่น่าตื่นเต้น ระวังตัวเลือกการแนะนำเพื่อนในบัญชีของคุณ",

  "Dashboard_Promocode_Usepromo" : "ใช้รหัสโปรโมชัน",
  "Dashboard_Promocode_to" : "ถึง",
  "Dashboard_Promocode_earnminimum_1" : "รับขั้นต่ำ",
  "Dashboard_Promocode_earnminimum_2" : "คะแนนพิเศษ",
  "Dashboard_Promocode_minimum" : "ขั้นต่ำ",
  "Dashboard_Promocode_minimumextrapoints" : "คะแนนพิเศษในทุกการสำรวจเสร็จสมบูรณ์ในวันนี้",
  "Dashboard_Promocode_apply" : "ใช้",
  "Dashboard_Promocode_message1" : "รหัสโปรโมชั่นไม่ถูกต้อง!",
  "Dashboard_Promocode_message2" : "ขอแสดงความยินดี! คุณจะได้รับขั้นต่ำ",
  "Dashboard_Promocode_message3" : "เพิ่มเติมในแต่ละการสำรวจเสร็จสมบูรณ์ในวันนี้!",

  "Dashboard_modal_Enjoythefestive" : "เพลิดเพลินไปกับจิตวิญญาณของวันหยุดด้วยการรับคะแนนพิเศษอย่างน้อย",
  "Dashboard_modal_Extrapointson" : "ในทุกการสำรวจที่คุณทำในวันนี้",

  "refer_friend_title" : "แนะนำเพื่อนและรับรางวัล",
  "refer_friend_step_first": "เชิญเพื่อนเข้าร่วม WisePerks",
  "refer_friend_step_second": "เพื่อนสมัครใช้งาน WisePerks สำเร็จแล้ว",
  "refer_friend_step_third": "คุณได้รับ each_referral คะแนน",
  "refer_friend_link_title": "เชิญเพื่อนตอนนี้!",
  "refer_friend_share_title": "แบ่งปันลิงค์",
  "refer_friend_guideline_title": '"อ้างอิงเพื่อน" จะเป็นประโยชน์ต่อคุณอย่างไร:',
  "refer_friend_guideline_one": "โปรดแชร์ลิงก์ที่ให้ไว้ข้างต้นกับการอ้างอิงของคุณ",
  "refer_friend_guideline_two": "คุณสามารถอ้างอิงผู้คนได้มากเท่าที่คุณต้องการเมื่อผู้อ้างอิง 5 คนยืนยันบัญชีของพวกเขาและเริ่มกิจกรรมสำรวจคะแนนการอ้างอิงที่คุณได้รับจะถูกเพิ่มเข้าไปในบัญชีของคุณ",
  "refer_friend_guideline_three": "คุณจะได้รับ each_referral คะแนนสำหรับการอ้างอิงสำเร็จ (ด้วยบัญชีอีเมลที่ได้รับการยืนยันและกิจกรรมการสำรวจ)",
  "refer_friend_guideline_four": "คะแนนจะได้รับในสองขั้นตอน partial_referral คะแนนในการยืนยันอีเมลและ partial_second_referral คะแนนจากกิจกรรมการสำรวจโดยผู้อ้างอิงของคุณ",
  "refer_friend_guideline_five": "หลังจากประสบความสำเร็จในการอ้างอิง 5 ครั้ง (ด้วยบัญชีอีเมลที่ได้รับการยืนยันและกิจกรรมสำรวจ) ลิงก์ผู้อ้างอิงจะถูกปิดการใช้งาน",
	
  }
  
